import { render, staticRenderFns } from "./ListCandidate_case.vue?vue&type=template&id=2abf0e13&scoped=true"
import script from "./ListCandidate_case.vue?vue&type=script&lang=js"
export * from "./ListCandidate_case.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abf0e13",
  null
  
)

export default component.exports